// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"JL-z","carouselContainer":"KL-z"};